import { FC, useState } from "react"
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextAreaInput, TextInput } from "../../../components/controls/inputs";
import BaseCreator from "../../../components/creators/baseCreator";
import styles from './styles/ContractorGroupCreatorModal.module.scss'

interface ICreateModal {
    parentName?: string
    idParentGroup?: string
    name: string
    comment?: string
}
const ContractorGroupCreatorModal: FC<ICreatorModalProps<ICreateModal>> = (props) => {
    const [contractorGroup, setContractorGroup] = useState<ICreateModal>(props.data ?? {} as ICreateModal)
    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.contractors.' + value)
    return (
        <BaseCreator variant={props.variant} save={() => props.save({ ...contractorGroup })} cancel={props.cancel} valid={true}>
            <GridWrapper cols={3}>
                <TextInput label={baseT('parentFolder')} value={contractorGroup.parentName} disabled={true} />
                <TextInput label={baseT('name')} placeholder='Новая группа' value={contractorGroup.name} onChange={(value) => setContractorGroup({ ...contractorGroup, name: value as string })} />
                <TextAreaInput label={baseT('comment')} className={styles.field_Comment} value={contractorGroup.comment} onChange={(value) => setContractorGroup({ ...contractorGroup, comment: value as string })} />
            </GridWrapper>
        </BaseCreator>
    )
}

export default ContractorGroupCreatorModal